import wx from 'weixin-js-sdk';
import axios from 'axios';
var appid = 'wx1dd1b5ad5c4567dc';// 众禄基金服务号appid

const WX_API_ROOT = `${process.env.NODE_ENV==='production' ? 'https://m.zlfund.cn' : 'https://i.zlfund.cn'}`

export function WxConfig () {
    const wcnmwxURL = encodeURIComponent(window.location.href.split('#')[0])
window.initWx = function(shareUrl, imgUrl, title, desc){
    axios({
        method: 'post',
        // url: 'https://m.zlfund.cn/mobile/weixin/jsapisign/',
        url: `${WX_API_ROOT}/mobile/weixin/jsapisign/`,
        data: `appid=${appid}&url=${wcnmwxURL}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        timeout: 60000
    }).then(jsapi_sign => {
        wx.config({
            // debug: true,
            appId: appid,
            timestamp: jsapi_sign.data.timestamp,
            nonceStr: jsapi_sign.data.nonceStr,
            signature: jsapi_sign.data.signature,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone', 'hideMenuItems']
        });
        wx.ready(function() {
            var link = shareUrl;
            wx.onMenuShareTimeline({
                title: title,
                desc: desc,
                link: link,
                imgUrl: imgUrl,
                success: function() {
                },
                cancel: function() {
                }
            });
            wx.onMenuShareAppMessage({
                title: title,
                desc: desc,
                link: link,
                imgUrl: imgUrl,
                success: function() {
                },
                cancel: function() {
                }
            });

            wx.onMenuShareQQ({
                title: title,
                desc: desc,
                link: link,
                imgUrl: imgUrl,
                success: function() {
                },
                cancel: function() {
                }
            });

            wx.onMenuShareQZone({
                title: title,
                desc: desc,
                link: link,
                imgUrl: imgUrl,
                success: function() {
                },
                cancel: function() {
                }
            });

            wx.hideMenuItems({
                menuList: ['menuItem:copyUrl', 'menuItem:share:email', 'menuItem:openWithSafari', 'menuItem:openWithQQBrowser']
            });
        });
    })
}

}

